import { colors } from '../../constants';
const MuiTypography = {
  colorPrimary: {
    color: colors.textExtra.contrast
  },
  colorSecondary: {
    color: colors.textExtra.heading
  }
};
export default MuiTypography;